import moment from 'moment';

export default class Candle {
  constructor(data) {
    this.Id = data.Id;

    if (data.Time !== undefined) {
      this.Time = (data.Time === null) ? null : moment.utc(data.Time);
    }

    this.Open = data.Open;
    this.High = data.High;
    this.Low = data.Low;
    this.Close = data.Close;
    this.Volume = data.Volume;
    this.Realtime = data.Realtime;
  }

  // Return a formatted local time string for display
  getDisplayName() {
    return `${this.getTime()}`;
  }

  getTime() {
    return this.Time.local().format('L LTS');
  }

  // Return unix seconds (number) for charting
  getUnixSeconds() {
    if (!this.Time) return null;
    return Math.floor(this.Time.valueOf() / 1000);
  }
}
